import { ref } from 'vue'
import { defineStore } from 'pinia'
import { type RemoteDiagnoseEvent, type Params, AddressTypes } from '@/types/remote-diagnose'

export const useRemoteDiagnose = defineStore('remote-diagnose', () => {
  const state = ref<RemoteDiagnoseEvent>({
    client_type: 'Individual',
    client_name: '',
    client_email: '',
    vehicle_registration_number: '',
    vin: '',
    date: '',
    time: '',
    country_code: '',
    phone_number: '',
    additional_phone_number: '',
    question: '',
    amount: 10,
    address_shipping: {
      address_type: AddressTypes.SHIPPING,
      address_line1: '',
      address_line2: '',
      company_name: '',
      postal_code: '',
      country: '',
      city: ''
    },
    address_billing: {
      address_type: AddressTypes.BILLING,
      company_name: '',
      address_line1: '',
      address_line2: '',
      postal_code: '',
      country: '',
      city: ''
    },
    payment_method_types: ['ideal'],
    language: ['nl'],
    brand: '',
    model: '',
    new_client: true,
    client_mileage_state: '0',
    has_dongle: false,
    item: 'Remote diagnose',
    type_of_job: 'Diagnose',
    client_dsg_model: '',
    terms_and_conditions_accepted: false,
    payment_gateway: 'ideal',
    returnUrl: ''
  })

  const setParamsOnStore = (params: Params) => {
    state.value.phone_number = params.clientId.replace(params.countryCode, '')
    state.value.country_code = params.countryCode
    state.value.address_shipping = {
      ...state.value.address_shipping,
      country: params.country
    }
    state.value.address_billing = {
      ...state.value.address_billing,
      country: params.country
    }
  }

  const changePaymentMethods = (useIdeal: boolean, stripeActive = false) => {
    if (useIdeal) {
      // When Stripe is active it acts as the iDEAL backup gateway
      state.value.payment_gateway = stripeActive ? 'stripe' : 'ideal'
      state.value.payment_method_types = ['ideal']
    } else {
      state.value.payment_gateway = 'revolut'
      state.value.payment_method_types = ['card']
    }
  }

  return {
    state,
    setParamsOnStore,
    changePaymentMethods
  }
})
